export function generateCodeVerifier(length: number = 128): string {
  const charset =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~'
  const randomValues = new Uint8Array(length)
  crypto.getRandomValues(randomValues)

  let result = ''
  for (let i = 0; i < length; i++) {
    result += charset[randomValues[i] % charset.length]
  }

  return result
}

export async function generateCodeChallenge(
  codeVerifier: string,
): Promise<string> {
  const encoder = new TextEncoder()
  const data = encoder.encode(codeVerifier)
  const hash = await crypto.subtle.digest('SHA-256', data)

  return base64UrlEncode(hash)
}

function base64UrlEncode(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}

export function generateState(): string {
  const randomValues = new Uint8Array(16)
  crypto.getRandomValues(randomValues)

  return Array.from(randomValues)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

export function storePKCEParams(codeVerifier: string, state: string): void {
  sessionStorage.setItem('pkce_code_verifier', codeVerifier)
  sessionStorage.setItem('pkce_state', state)
}

export function retrievePKCEParams(): {
  codeVerifier: string | null
  state: string | null
} {
  return {
    codeVerifier: sessionStorage.getItem('pkce_code_verifier'),
    state: sessionStorage.getItem('pkce_state'),
  }
}

export function clearPKCEParams(): void {
  sessionStorage.removeItem('pkce_code_verifier')
  sessionStorage.removeItem('pkce_state')
}
